module.exports = __webpack_public_path__ + "static/media/man_songcheng.75c5b813.png";